import React, { useContext } from 'react';
import { getDefinition, ThemeContext, ViewerPropertiesComplete, getIcon } from '../model';
import classNames from 'classnames';
export const IconSelector: React.FC<{
  filename: string;
  defaultIcon: boolean;
  className?: string;
}> = ({ filename, defaultIcon, className = '' }) => {
  const Icon = getIcon(filename, defaultIcon);
  const theme = useContext(ThemeContext);
  if (Icon === undefined) return null;
  return <Icon className={`file-icon ${className} invert-${theme.invert}`} />;
};
export const FileOutlinedWithExtension: React.FC<{
  filename: string;
  className?: string;
}> = ({ filename, className }) => {
  const definition = getDefinition(filename);
  const invert = useContext(ThemeContext).invert;
  return (
    <div
      className={`gen-file-viewer__icon-group ${className ?? ''} invert-${invert} mt-${definition.mt}`}
    >
      <IconSelector defaultIcon filename={filename} />
      {definition.customIcon === undefined && (
        <span className="gen-file-viewer__file-extension">.{definition.extension}</span>
      )}
    </div>
  );
};

export const MediaUnknown: React.FC<ViewerPropertiesComplete> = ({ filename, compact }) => {
  const invert = useContext(ThemeContext).invert;
  return (
    <div className="ch-file-viewer__file">
      <FileOutlinedWithExtension filename={filename} />
      {!compact && (
        <div className={classNames('ch-file-viewer__file-name', `invert-${invert}`)}>
          {filename}
        </div>
      )}
    </div>
  );
};
